import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ThumbsUp } from '../../../../../UI/Icons/Icons';

import './product-question-answers.scss';

//api format
//https://readservices-b2c.powerreviews.com/m/689225/l/en_US/product/05689339/questions?apikey=e17667f7-827b-4880-8fe1-ab55b0a692b9
export class ProductDetailQuestionAnswers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.sortOrder = 'Newest';

    this.fetchQuestionAnswers = this.fetchQuestionAnswers.bind(this);
    this.updateSortBy = this.updateSortBy.bind(this);
    this.goToNextPage = this.goToNextPage.bind(this);
    this.goToPrevPage = this.goToPrevPage.bind(this);
    this.goToReviewSection = this.goToReviewSection.bind(this);
  }
  scrollToTop() {
    $('html, body').animate(
      {
        scrollTop: 0,
      },
      500
    );
  }
  goToReviewSection() {
    var headerOffset = 115;
    if (this.props.passedAppFunctions.siteFormat == 'mobile') {
      headerOffset = 0;
    }
    $('html, body').animate(
      {
        scrollTop: $('.question-answer-section').offset().top - headerOffset,
      },
      500
    );
  }
  goToNextPage() {
    this.goToReviewSection();
    this.state.pagingFrom = (this.state.pagingFrom || 0) + 10;
    this.fetchQuestionAnswers();
  }
  goToPrevPage() {
    this.goToReviewSection();
    this.state.pagingFrom = Math.max(this.state.pagingFrom, 10) - 10;
    this.fetchQuestionAnswers();
  }
  shouldComponentUpdate(nextProps, nextState) {
    //only update if salePage param changes, productId changes, or reviews get populates, or new data arrives in apiResponse
    if (
      this.props.contentData.salePage != nextProps.contentData.salePage ||
      this.props.contentData.productId != nextProps.contentData.productId ||
      this.state.liveQuestionAnswerCount != nextState.liveQuestionAnswerCount ||
      nextState.apiResponse
    ) {
      return true;
    }
    return false;
  }
  componentDidMount() {
    this.fetchQuestionAnswers();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.contentData.productId && this.props.contentData.productId != prevProps.contentData.productId) {
      //need to call for new reviews after dumping old
      this.state.liveQuestionAnswerCount = false;
      this.state.pagingFrom = false;
      this.state.sortOrder = 'Newest';
      this.fetchQuestionAnswers();
    }
  }
  updateSortBy(e) {
    // Acceptable fields include LowestRating, HighestRating, MostHelpful, Oldest, Newest.
    var newValue = e.target.value;
    var oldValue = this.state.sortOrder;
    var acceptableFields = ['Oldest', 'Newest'];
    if (newValue != oldValue && acceptableFields.indexOf(newValue) > -1) {
      this.state.sortOrder = newValue;
      this.state.pagingFrom = false;
      this.fetchQuestionAnswers();
    }
  }

  fetchQuestionAnswers() {
    try {
      if (
        this.props.contentData.partNumber &&
        this.props.contentData.questionAnswerCount > 0 &&
        this.props.contentData.brandNameForTitle == 'UGG'
      ) {
        var merchantId = this.props.passedAppFunctions.wasParms.powerReviewsMerchantId;
        var locale = 'en_US';
        var pageId = this.props.contentData.partNumber;
        var apiKey = this.props.passedAppFunctions.wasParms.powerReviewsAPIKey;
        // merchantId = '689225';
        // apiKey = 'e17667f7-827b-4880-8fe1-ab55b0a692b9';//testing prod reviews

        var apiUrl = `https://readservices-b2c.powerreviews.com/m/${merchantId}/l/${locale}/product/${pageId}/questions?apikey=${apiKey}&paging.size=10&sort=${this.state.sortOrder}`;
        if (this.state.pagingFrom) {
          apiUrl += `&paging.from=${this.state.pagingFrom}`;
        }

        var axiosConfig = {
          url: apiUrl,
        };

        axios(axiosConfig).then((ajaxResponse) => {
          var responseData = ajaxResponse.data;
          var apiResponse = responseData.results;
          var apiPaging = responseData.paging;

          if (apiResponse) {
            var liveQuestionAnswerCount = apiPaging.total_results;
            this.props.passedFunctions.updateLiveQuestionAnswersCount(liveQuestionAnswerCount);
            this.setState({
              apiResponse: apiResponse,
              liveQuestionAnswerCount: liveQuestionAnswerCount,
              apiPaging: apiPaging,
            });
          } else {
            if (apiPaging && (apiPaging.total_results || 0) == 0) {
              this.props.passedFunctions.updateLiveQuestionAnswersCount('0');
              this.setState({ liveQuestionAnswerCount: '0' });
            } else {
              this.setState({ apiResponse: apiResponse, apiPaging: apiPaging });
            }
          }
        });
      } else {
        this.props.passedFunctions.updateLiveQuestionAnswersCount('0');
        this.setState({ liveQuestionAnswerCount: '0' });
      }
    } catch (e) {
      // console.log(e);
      this.setState({ liveQuestionAnswerCount: false });
    }
  }

  timeAgoFromTimestamp(timestamp) {
    var daysAgo = Math.max(Math.round((new Date().getTime() - new Date(timestamp).getTime()) / 86400000), 1);
    var unitToShow = 'year';
    var numberToShow = 0;
    if (daysAgo <= 30) {
      unitToShow = 'day';
      numberToShow = daysAgo;
    } else if (daysAgo < 365) {
      unitToShow = 'month';
      numberToShow = Math.round(daysAgo / 30);
    } else {
      numberToShow = Math.round(daysAgo / 365);
    }
    return `${numberToShow} ${unitToShow}${numberToShow > 1 ? 's' : ''} ago`;
  }
  render() {
    var answerCount = (this.state.liveQuestionAnswerCount || this.props.contentData.questionAnswerCount || 0) * 1;

    if (!(answerCount > 0 && this.state.apiResponse)) {
      return null;
    }

    return (
      <div className='col-sm-12 m-30 p-t-20 question-answer-section justify-content-md-center'>
        <div className='row align-items-stretch p-b-25'>
          <h2 className='col-11'>
            <strong>Question & Answers</strong>
          </h2>
          <div className='col-sm-1' id='pr-qa-sort-by'>
            <label htmlFor='questionanswerSortBy' className='sr-only'>
              Sort Reviews By
            </label>
            <select className='form-control' onChange={this.updateSortBy} id='questionanswerSortBy'>
              <option value='Newest'>Newest</option>
              <option value='Oldest'>Oldest</option>
            </select>
          </div>
        </div>
        <div className='col-sm-12 justify-content-md-center' id='pr-questionanswerdisplay'>
          <div className='row m-b-10'>
            <div className='col-sm-12'>
              {this.state.apiResponse.map((thisReview) => {
                return (
                  <div key={thisReview.ugc_id} className='col-sm-12 row p-b-25'>
                    <div className='row pr-qa-innerRow'>
                      <div className='col-sm-1'>
                        <p>
                          <strong>Question:</strong>
                        </p>
                      </div>
                      <div className='col-sm-11'>
                        <p className='pr-qa-question'>{thisReview.details.text}</p>
                      </div>

                      <div className='col-sm-1'>
                        <p>
                          <strong>Answer:</strong>
                        </p>
                      </div>
                      <div className='col-sm-11'>
                        <p>{thisReview.answer[0].details.text}</p>
                      </div>

                      <div className='col-sm-1'></div>
                      <div className='col-sm-2 reviews-section'>
                        <p id='pr-author-details'>
                          {thisReview.answer[0].details.nickname}
                          {thisReview.answer[0].details.is_expert ? ' -- Expert' : ''}
                        </p>
                      </div>
                      <div className='col-sm-2 reviews-section'>
                        <p id='pr-author-details'>
                          <span className='p-1'>
                            <ThumbsUp />
                          </span>
                          {thisReview.answer[0].metrics.helpful_votes} people found this helpful
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className='col-sm-4 reviews-count'>
              {answerCount > 1 && (
                <>
                  Displaying questions{' '}
                  <b>
                    {(this.state.apiPaging.current_page_number - 1) * 10 + 1}-
                    {Math.min(this.state.apiPaging.current_page_number * 10, this.state.apiPaging.total_results)}
                  </b>
                </>
              )}
            </div>
            <div className='col-sm-4 reviews-back-top'>
              <button className='btn btn-tertiary' onClick={this.goToReviewSection}>
                back to top
              </button>
              <span className='sr-only'> of question and answers section</span>
            </div>
            <div className='col-sm-4 reviews-pagination'>
              {this.state.apiPaging.pages_total > 1 && (
                <>
                  {this.state.apiPaging.current_page_number > 1 && (
                    <span className='btn btn-tertiary' onClick={this.goToPrevPage}>
                      Previous
                    </span>
                  )}
                  {this.state.apiPaging.current_page_number > 1 &&
                    this.state.apiPaging.current_page_number < this.state.apiPaging.pages_total &&
                    '|'}
                  {this.state.apiPaging.current_page_number < this.state.apiPaging.pages_total && (
                    <span className='btn btn-tertiary' onClick={this.goToNextPage}>
                      Next
                    </span>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDetailQuestionAnswers;
